export default "__VITE_ASSET__CJHy2vl___"